export default __webpack_public_path__ + "static/spark_add_account1-dcdb07428f04a9a6061fd0e0592b90c8.png";